import { baseApi } from './baseApi';
import { normalizeKeys } from '../../utils/transform';

export interface ConversationResult {
  conversationId: string;
  status: 'processing' | 'completed' | 'failed';
  result?: {
    response: string;
    metadata?: Record<string, any>;
  };
  s3Reference?: string;
  createdAt: string;
}

export const conversationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConversation: builder.query<ConversationResult, string>({
      query: (conversationId) => `/conversations/${conversationId}`,
      transformResponse: (raw: unknown) =>
        normalizeKeys<ConversationResult>(raw),
    }),
  }),
});

export const { useGetConversationQuery, useLazyGetConversationQuery } =
  conversationsApi;
